module.exports = __webpack_public_path__ + "img/precision-punch.89d751bf.svg";